import { render, staticRenderFns } from "./LiveTradeDetails.vue?vue&type=template&id=1ba4e6f4"
import script from "./LiveTradeDetails.vue?vue&type=script&lang=js"
export * from "./LiveTradeDetails.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports